import {createStore, applyMiddleware, combineReducers} from 'redux';
import { persistCombineReducers, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { createReduxHistoryContext } from "redux-first-history";
import { reducer as toastr } from 'react-redux-toastr';
import thunk from 'redux-thunk';
import {createHashHistory} from 'history';

import products from './views/Products/reducer';
import reviews from './components/Reviews/reducer';
import cart from './views/Cart/reducer';
import variations from './components/Variations/reducer';
import search from './views/Search/reducer';
import navtopbar from './components/NavTopBar/reducer';
import navbottombar from './components/NavBottomBar/reducer';
import address from './components/AddressCard/reducer';
import userLogin from './components/UserLogin/reducer';
import userLocation from './components/GeoLocation/reducer';
import orders from './views/Orders/reducer';
import ordersGrouped from './views/OrdersGrouped/reducer';
import faq from './views/FAQ/reducer';
import instructions from './views/Instructions/reducer';
import serials from "./components/ModalScale/reducer";

export const mergeObjectArrays = (fromArray, toArray) => {

    let newArray = structuredClone(toArray);
    _.forEach(fromArray, (element) => {
        const index = newArray.findIndex(x => x.id === element.id);
        if (index !== -1)
            newArray[index] = element;
        else
            newArray.push(element);
    });

    //console.log('mergeObjectArrays', toArray, fromArray, newArray);
    return newArray;
}

const { createReduxHistory, routerMiddleware, routerReducer } =
    createReduxHistoryContext({
        history: createHashHistory(),
        savePreviousLocations: 2,
});

const rootPersistConfig = {
  key: 'root',
  storage,
  blacklist: [
        'navtopbar',
        'navbottombar',
        'toastr',
        'router',
  ],
   //debug: true,
};

const rootReducer = persistCombineReducers(rootPersistConfig, {
  products: persistReducer(
    {
      key: 'products',
      storage,
      blacklist: ['isFetching', 'hasMore'],
    },
    products,
  ),
  reviews: persistReducer(
    {
      key: 'reviews',
      storage,
      blacklist: ['isFetching'],
    },
    reviews,
  ),
  variations: persistReducer(
    {
      key: 'variations',
      storage,
      blacklist: ['isFetching'],
    },
    variations,
  ),
  cart: persistReducer(
    {
      key: 'cart',
      storage,
    },
    cart,
  ),
  navtopbar,
  navbottombar,
  search: persistReducer(
      {
          key: 'search',
          storage,
          blacklist: ['isFetching', 'hasMore'],
      },
      search,
  ),
  toastr,
  address: persistReducer(
    {
      key: 'address',
      storage,
        blacklist: ['isFetching', 'hasMore'],
    },
    address,
  ),
  userLogin: persistReducer(
    {
      key: 'userLogin',
      storage,
        blacklist: ['isFetching', 'hasMore'],
    },
    userLogin,
  ),
  userLocation: persistReducer(
    {
      key: 'userLocation',
      storage,
    },
    userLocation,
  ),
  orders: persistReducer(
        {
            key: 'orders',
            storage,
            blacklist: ['isFetching', 'hasMore'],
        },
        orders,
    ),
    ordersGrouped: persistReducer(
        {
            key: 'ordersGrouped',
            storage,
            blacklist: ['isFetching', 'hasMore'],
        },
        ordersGrouped,
    ),
    faq: persistReducer(
        {
            key: 'faq',
            storage,
            blacklist: ['isFetching', 'hasMore'],
        },
        faq,
    ),
    instructions: persistReducer(
        {
            key: 'instructions',
            storage,
            blacklist: ['isFetching', 'hasMore'],
        },
        instructions,
    ),
    serials: persistReducer(
        {
            key: 'serials',
            storage,
            blacklist: [],
        },
        serials,
    ),
  router: routerReducer,
});


export const store = createStore(
    rootReducer,
    undefined,
    applyMiddleware(thunk, routerMiddleware)
);

export const routerHistory = createReduxHistory(store);
export const persistor = persistStore(store);
